module.exports = __webpack_public_path__ + "img/FR21670.59e3b3e2.png";